import React from "react";
import Table from "../CommonTable";
import { CONSTANTS } from "../../shared/constants";
import moment from "moment";
import { Favourite, Info, NotFavourite } from "../../icons";
import { useMediaQuery } from "react-responsive";

const FinishedCard = ({ record, card }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  return (
    <div className="process-card">
      {record && (
        <div>
          <Table rows={[record]} isMobile={isMobile} />
          <BidInfo record={record} />
        </div>
      )}
      {card && (
        <div>
          <Card cards={card} />
          <BidInfo record={card} />
        </div>
      )}
    </div>
  );
};

const BidInfo = ({ record }) => {
  return (
    <>
      <div className="bid-info success-info-box">
        <div className="prices">
          <div>
            <span className="bidInfoDetails">BTC offer Price：</span>
            <span className="bidInfoDetailPrice">
              {record.vehicle.discountPrice.toLocaleString()} Yen{" "}
            </span>
          </div>
          <div>
            <span className="bidInfoDetails">Total Price： </span>
            <span className="bidInfoDetailPrice">
              {" "}
              {record.totalPrice.toLocaleString()} Yen{" "}
            </span>
          </div>
          <div>
            <span className="bidInfoDetails"> Bid Price：</span>
            <span className="bidInfoDetailPrice">{record.bidPrice} Yen </span>
          </div>
          <div>
            <span className="bidInfoDetails">Total Price：</span>
            <span className="bidInfoDetailPrice">
              {record.totalPrice.toLocaleString()} Yen{" "}
            </span>
          </div>
        </div>
        <div
          style={{
            width: "48%",
            transform: "translateY(-20px)",
          }}
        >
          {CONSTANTS.OFFER_STATUS.ACCEPTED === record.status ? (
            <div className="successful-offer" style={{ padding: 5 }}>
              Your Offer has been successful.
            </div>
          ) : (
            <div className="not successful-offer" style={{ padding: 5 }}>
              Your offer has not been successful.
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const Card = ({ cards }) => {
  const getDate = (date) => {
    if (date) {
      const japanDateTime = moment(date).format("YYYY-MM-DD");

      return japanDateTime;
    }

    return "";
  };
  return (
    <div key={cards} className="mainCardslistSearch">
      <div className="containerSearchCardsPF">
        <div className="searchimagecontainerFinishedcard">
          <img
            className="search-Imglist"
            src={`${process.env.REACT_APP_BTC_API_URL}/${cards?.vehicle?.thumbnail}`}
            alt={`${process.env.REACT_APP_BTC_API_URL}/${cards?.vehicle?.thumbnail}`}
          />
        </div>
        <div className="cardscontentcontainerF">
          <div className="contentSearchPF">
            <a
              style={{ marginTop: 8, fontSize: 11, fontWeight: 800 }}
              href="#auctionno"
            >
              No.{cards?.vehicle?.auctionNo}
            </a>

            <div className="damagedUsedContainer">
              {cards?.vehicle?.condition === "DAMAGE" && (
                <button className="damagedcard">
                  <span className="some_thing">Damaged</span>
                </button>
              )}
              {cards?.vehicle?.condition === "USED" && (
                <button className="usedcard">
                  <span className="some_thing">Used</span>
                </button>
              )}
              <div className="iconContainer">
                {cards?.vehicle?.isFavorite === true ? (
                  <Favourite style={{ width: 17, height: 17, marginTop: 1 }} />
                ) : (
                  <NotFavourite
                    style={{ width: 17, height: 17, marginTop: 1 }}
                  />
                )}
              </div>
            </div>
          </div>
          <div style={{ marginTop: -7 }}>
            <span className="cardNameSearch">{cards?.vehicle?.name}</span>
          </div>
          <div style={{ marginTop: -5 }}>
            <span
              style={{ color: "#dc0000", fontWeight: "bold", fontSize: 12 }}
            >
              {cards?.vehicle?.discountPrice.toLocaleString()} Yen
            </span>
          </div>
          <span style={{ display: "flex" }}>
            <b style={{ fontSize: 10, color: "black" }}>
              {cards?.vehicle?.auctionType ===
              CONSTANTS.AUCTION_TYPES.NEGOTIATION
                ? "NEGOTIATION"
                : `${cards?.vehicle?.auctionType} :`}
            </b>
            <span className="auctionendDate">
              {getDate(cards?.vehicle?.auctionEndDate)}
            </span>
          </span>
          <div style={{ display: "flex", marginTop: 2 }}>
            <b style={{ fontSize: 10 }}>Location : </b>
            <b className="currentAddressSearch">
              {" "}
              {cards?.vehicle?.currentAddress}{" "}
            </b>
            <Info className="infoIcon" />
          </div>
          <div>
            <p className="detailsofVehicle">
              {cards?.vehicle?.year} &nbsp; | &nbsp;&nbsp;{" "}
              {cards?.vehicle?.mileage?.toLocaleString()} km &nbsp; |
              &nbsp;&nbsp;
              {cards?.vehicle?.displacement?.toLocaleString()} cc &nbsp; |
              &nbsp;&nbsp;
              {cards?.vehicle?.fuel}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FinishedCard;
